import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { sanityClient } from "../utils/sanityClient";
import BlogPostCard from "../components/BlogPostCard";
import blogHeroImage from "../assets/blog-hero.jpg";

const POSTS_QUERY = `*[_type == "post" && publishedAt <= now()] | order(publishedAt desc){
  _id,
  title,
  slug,
  excerpt,
  mainImage,
  publishedAt,
  "authorName": author->name
}`;

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    sanityClient
      .fetch(POSTS_QUERY)
      .then((data) => setPosts(data || []))
      .catch(() => setFetchError(true))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="page-container overflow-y-auto font-poppins">
      <Helmet>
        <title>Blog | LasGidi Restaurant</title>
        <meta name="description" content="News, recipes and stories from LasGidi Restaurant in Manchester." />
        <meta property="og:title" content="Blog | LasGidi Restaurant" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Hero banner */}
      <div className="relative w-full h-[200px] mb-10 flex items-center justify-center overflow-hidden">
        <img
          src={blogHeroImage}
          alt="Our Blog"
          className="absolute inset-0 w-full h-full object-cover"
          fetchpriority="high"
          loading="eager"
        />
        <div className="absolute inset-0 bg-black/50" />
        <h1 className="relative z-10 text-white text-4xl font-bold font-prata">Our Blog</h1>
      </div>

      <div className="standard-padding">

      {isLoading && (
        <p className="text-center text-white/60 py-20">Loading posts...</p>
      )}

      {!isLoading && fetchError && (
        <p className="text-center text-white/60 py-20">
          We couldn't load the blog right now. Please try again later.
        </p>
      )}

      {!isLoading && !fetchError && posts.length === 0 && (
        <p className="text-center text-white/60 py-20">No posts yet — check back soon.</p>
      )}

      {!isLoading && !fetchError && posts.length > 0 && (
        <div className="grid grid-cols-1 min-[421px]:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-14 mb-20">
          {posts.map((post) => (
            <BlogPostCard key={post._id} post={post} />
          ))}
        </div>
      )}

      </div>
    </div>
  );
};

export default BlogPage;
